// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   FooterPage — footer + fixed enroll bar
   Prefix: upskld_footer_pg_ · no :root variables · no green
   ============================================================ */

.upskld_footer_pg_wrapper {
  position: relative;
  width: 100%;
  /* extra bottom space so the fixed enroll bar never covers the last lines */
  padding: 44px 24px 120px;
  background: linear-gradient(180deg, #f1e9fc 0%, #f3ecfd 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  color: #3d3858;
}

.upskld_footer_pg_wrapper *,
.upskld_footer_pg_wrapper *::before,
.upskld_footer_pg_wrapper *::after {
  box-sizing: border-box;
}

.upskld_footer_pg_container {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
}

/* ---------- Entrance: fade up ---------- */

.upskld_footer_pg_reveal {
  opacity: 0;
  transform: translateY(22px);
  transition:
    opacity 0.8s ease var(--d, 0ms),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);
}

.upskld_footer_pg_in .upskld_footer_pg_reveal {
  opacity: 1;
  transform: none;
}

/* ============================================================
   Top row: brand | navigation | social icons
   ============================================================ */

.upskld_footer_pg_top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  column-gap: 40px;
}

.upskld_footer_pg_brand {
  min-width: 0;
}

.upskld_footer_pg_logo {
  margin: 0 0 8px;
  font-size: 19px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.2;
  color: #55024f;
}

.upskld_footer_pg_about {
  margin: 0;
  max-width: 340px;
  font-size: 13px;
  line-height: 1.55;
  color: #5d5978;
}

.upskld_footer_pg_link_list,
.upskld_footer_pg_socials,
.upskld_footer_pg_legal {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}

.upskld_footer_pg_link_list {
  justify-content: center;
  gap: 12px 30px;
}

.upskld_footer_pg_socials {
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 12px;
}

.upskld_footer_pg_socials li {
  display: flex;
}

/* ---------- Text links ---------- */

.upskld_footer_pg_link {
  position: relative;
  display: inline-block;
  padding: 2px 0;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.4;
  color: #4a4663;
  text-decoration: none;
  transition: color 0.3s ease, transform 0.3s ease;
}

/* underline that grows from the left on hover */
.upskld_footer_pg_link::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #4a1a9e 0%, #e0a83d 100%);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.upskld_footer_pg_link:hover {
  color: #4a1a9e;
  transform: translateY(-2px);
}

.upskld_footer_pg_link:hover::after {
  transform: scaleX(1);
}

.upskld_footer_pg_link_small {
  font-size: 12px;
  font-weight: 500;
}

/* ---------- Social icon buttons ---------- */

.upskld_footer_pg_social_btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border: 1px solid rgba(74, 26, 158, 0.18);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.75);
  box-shadow: 0 6px 16px rgba(74, 26, 158, 0.08);
  color: #4a1a9e;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  transition:
    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    background 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}

.upskld_footer_pg_social_btn svg {
  display: block;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.upskld_footer_pg_social_btn:hover {
  transform: translateY(-3px);
  border-color: transparent;
  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 12px 24px rgba(74, 26, 158, 0.32);
  color: #ffffff;
}

.upskld_footer_pg_social_btn:active {
  transform: scale(0.94);
}

/* ---------- Focus ---------- */

.upskld_footer_pg_link:focus-visible,
.upskld_footer_pg_social_btn:focus-visible,
.upskld_footer_pg_bar_enquire:focus-visible,
.upskld_footer_pg_bar_enroll:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 3px;
  border-radius: 4px;
}

.upskld_footer_pg_social_btn:focus-visible {
  border-radius: 50%;
}

/* ============================================================
   Divider + bottom row
   ============================================================ */

.upskld_footer_pg_divider {
  height: 1px;
  margin: 28px 0 22px;
  background: linear-gradient(90deg, rgba(74, 26, 158, 0.08) 0%, rgba(74, 26, 158, 0.22) 50%, rgba(74, 26, 158, 0.08) 100%);
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s;
}

.upskld_footer_pg_in .upskld_footer_pg_divider {
  transform: scaleX(1);
}

.upskld_footer_pg_bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px 40px;
}

.upskld_footer_pg_sources {
  max-width: 580px;
  margin: 0;
  font-size: 11.5px;
  line-height: 1.6;
  color: #5d5978;
}

.upskld_footer_pg_legal {
  flex-shrink: 0;
  gap: 8px 22px;
}

/* ============================================================
   Enroll bar (fixed)
   ============================================================ */

.upskld_footer_pg_bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 900;
  padding: 14px 24px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(14px);
  box-shadow: 0 -14px 40px rgba(74, 26, 158, 0.14);
  font-family: "Manrope", "Roboto", sans-serif;
  transform: translateY(110%);
  opacity: 0;
  pointer-events: none;
  transition:
    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.5s ease;
}

.upskld_footer_pg_bar *,
.upskld_footer_pg_bar *::before,
.upskld_footer_pg_bar *::after {
  box-sizing: border-box;
}

.upskld_footer_pg_bar_visible {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.upskld_footer_pg_bar_inner {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
}

.upskld_footer_pg_bar_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 8px 18px rgba(74, 26, 158, 0.32);
  color: #ffffff;
}

.upskld_footer_pg_bar_text {
  flex: 1 1;
  min-width: 0;
}

.upskld_footer_pg_bar_title {
  margin: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.35;
  color: #0f0a2a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upskld_footer_pg_bar_status {
  margin: 1px 0 0;
  font-size: 12px;
  line-height: 1.35;
  color: #6b6784;
}

.upskld_footer_pg_bar_actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
}

.upskld_footer_pg_bar_enquire,
.upskld_footer_pg_bar_enroll {
  padding: 11px 22px;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease, background 0.3s ease;
}

.upskld_footer_pg_bar_enquire {
  border: 1px solid #e4dcf9;
  background: #f0e8ff;
  color: #4a1a9e;
}

.upskld_footer_pg_bar_enquire:hover {
  background: #e4d6ff;
  transform: translateY(-2px);
}

.upskld_footer_pg_bar_enroll {
  border: 0;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.34);
  color: #ffffff;
}

.upskld_footer_pg_bar_enroll:hover {
  transform: translateY(-3px);
  filter: brightness(1.12);
  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.42);
}

.upskld_footer_pg_bar_enquire:active,
.upskld_footer_pg_bar_enroll:active {
  transform: scale(0.96);
}

/* ============================================================
   Responsive — 1100 / 820 / 560 / 360
   ============================================================ */

@media (max-width: 1100px) {
  .upskld_footer_pg_wrapper {
    padding: 40px 20px 116px;
  }

  .upskld_footer_pg_top {
    column-gap: 28px;
  }

  .upskld_footer_pg_link_list {
    gap: 12px 22px;
  }
}

/* tablet: brand on its own row, links left + icons right on the next row */
@media (max-width: 820px) {
  .upskld_footer_pg_top {
    grid-template-columns: minmax(0, 1fr) auto;
    row-gap: 24px;
    column-gap: 20px;
  }

  .upskld_footer_pg_brand {
    grid-column: 1 / -1;
  }

  .upskld_footer_pg_about {
    max-width: none;
  }

  .upskld_footer_pg_link_list {
    justify-content: flex-start;
  }

  .upskld_footer_pg_socials {
    justify-content: flex-end;
  }

  .upskld_footer_pg_bar {
    padding: 12px 20px;
  }
}

/* mobile: everything stacks, left aligned */
@media (max-width: 560px) {
  .upskld_footer_pg_wrapper {
    padding: 34px 16px 150px;
  }

  .upskld_footer_pg_top {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 22px;
  }

  .upskld_footer_pg_logo {
    font-size: 18px;
  }

  .upskld_footer_pg_link_list {
    gap: 10px 20px;
  }

  .upskld_footer_pg_socials {
    justify-content: flex-start;
    gap: 12px;
  }

  .upskld_footer_pg_divider {
    margin: 24px 0 18px;
  }

  .upskld_footer_pg_bottom {
    flex-direction: column;
    gap: 16px;
  }

  /* enroll bar: text on top, two buttons below, full width */
  .upskld_footer_pg_bar {
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  }

  .upskld_footer_pg_bar_inner {
    flex-wrap: wrap;
    gap: 10px 12px;
  }

  .upskld_footer_pg_bar_icon {
    width: 34px;
    height: 34px;
  }

  .upskld_footer_pg_bar_title {
    font-size: 13px;
  }

  .upskld_footer_pg_bar_actions {
    width: 100%;
    gap: 8px;
  }

  .upskld_footer_pg_bar_enquire,
  .upskld_footer_pg_bar_enroll {
    flex: 1 1;
    padding: 12px 14px;
  }
}

@media (max-width: 360px) {
  .upskld_footer_pg_link {
    font-size: 13px;
  }

  .upskld_footer_pg_social_btn {
    width: 42px;
    height: 42px;
  }

  .upskld_footer_pg_bar_title {
    font-size: 12.5px;
  }
}

/* ============================================================
   Reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .upskld_footer_pg_reveal {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }

  .upskld_footer_pg_divider {
    transform: scaleX(1) !important;
    transition: none !important;
  }

  .upskld_footer_pg_bar {
    transition: opacity 0.2s ease !important;
    transform: none !important;
  }

  .upskld_footer_pg_link,
  .upskld_footer_pg_link::after,
  .upskld_footer_pg_social_btn {
    transition: none !important;
  }
}

/* ---- header tab switch: program name + status fade in again ---- */
.upskld_footer_pg_bar_text {
  animation: upskld_footer_pg_bar_swap 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes upskld_footer_pg_bar_swap {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .upskld_footer_pg_bar_text {
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/HeadFootPage/FooterPage/FooterPage.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,2EAA2E;EAC3E,wBAAwB;EACxB,6DAA6D;EAC7D,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4CAA4C;;AAE5C;EACE,UAAU;EACV,2BAA2B;EAC3B;;+DAE6D;AAC/D;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,4DAA4D;EAC5D,oBAAoB;EACpB,6BAA6B;EAC7B,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8CAA8C;;AAE9C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,qCAAqC;EACrC,8CAA8C;EAC9C,cAAc;EACd,qBAAqB;EACrB,wCAAwC;EACxC;;;;;wBAKsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6DAA6D;EAC7D,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;;AAEhC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,mBAAmB;EACnB,yHAAyH;EACzH,oBAAoB;EACpB,6BAA6B;EAC7B,8DAA8D;AAChE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;iEAEiE;;AAEjE;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EAErC,2BAA2B;EAC3B,gDAAgD;EAChD,4CAA4C;EAC5C,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB;;qBAEmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,6DAA6D;EAC7D,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6FAA6F;AAC/F;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,6DAA6D;EAC7D,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA,2DAA2D;EAC3D;IACE,gEAAgE;EAClE;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,wCAAwC;IACxC,0BAA0B;EAC5B;;EAEA;;;IAGE,2BAA2B;EAC7B;AACF;;AAEA,qEAAqE;AACrE;EACE,6EAA6E;AAC/E;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   FooterPage — footer + fixed enroll bar\n   Prefix: upskld_footer_pg_ · no :root variables · no green\n   ============================================================ */\n\n.upskld_footer_pg_wrapper {\n  position: relative;\n  width: 100%;\n  /* extra bottom space so the fixed enroll bar never covers the last lines */\n  padding: 44px 24px 120px;\n  background: linear-gradient(180deg, #f1e9fc 0%, #f3ecfd 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  color: #3d3858;\n}\n\n.upskld_footer_pg_wrapper *,\n.upskld_footer_pg_wrapper *::before,\n.upskld_footer_pg_wrapper *::after {\n  box-sizing: border-box;\n}\n\n.upskld_footer_pg_container {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n/* ---------- Entrance: fade up ---------- */\n\n.upskld_footer_pg_reveal {\n  opacity: 0;\n  transform: translateY(22px);\n  transition:\n    opacity 0.8s ease var(--d, 0ms),\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);\n}\n\n.upskld_footer_pg_in .upskld_footer_pg_reveal {\n  opacity: 1;\n  transform: none;\n}\n\n/* ============================================================\n   Top row: brand | navigation | social icons\n   ============================================================ */\n\n.upskld_footer_pg_top {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: center;\n  column-gap: 40px;\n}\n\n.upskld_footer_pg_brand {\n  min-width: 0;\n}\n\n.upskld_footer_pg_logo {\n  margin: 0 0 8px;\n  font-size: 19px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n  color: #55024f;\n}\n\n.upskld_footer_pg_about {\n  margin: 0;\n  max-width: 340px;\n  font-size: 13px;\n  line-height: 1.55;\n  color: #5d5978;\n}\n\n.upskld_footer_pg_link_list,\n.upskld_footer_pg_socials,\n.upskld_footer_pg_legal {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.upskld_footer_pg_link_list {\n  justify-content: center;\n  gap: 12px 30px;\n}\n\n.upskld_footer_pg_socials {\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  gap: 12px;\n}\n\n.upskld_footer_pg_socials li {\n  display: flex;\n}\n\n/* ---------- Text links ---------- */\n\n.upskld_footer_pg_link {\n  position: relative;\n  display: inline-block;\n  padding: 2px 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #4a4663;\n  text-decoration: none;\n  transition: color 0.3s ease, transform 0.3s ease;\n}\n\n/* underline that grows from the left on hover */\n.upskld_footer_pg_link::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -2px;\n  height: 2px;\n  border-radius: 2px;\n  background: linear-gradient(90deg, #4a1a9e 0%, #e0a83d 100%);\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.upskld_footer_pg_link:hover {\n  color: #4a1a9e;\n  transform: translateY(-2px);\n}\n\n.upskld_footer_pg_link:hover::after {\n  transform: scaleX(1);\n}\n\n.upskld_footer_pg_link_small {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* ---------- Social icon buttons ---------- */\n\n.upskld_footer_pg_social_btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border: 1px solid rgba(74, 26, 158, 0.18);\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.75);\n  box-shadow: 0 6px 16px rgba(74, 26, 158, 0.08);\n  color: #4a1a9e;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  transition:\n    transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),\n    background 0.3s ease,\n    color 0.3s ease,\n    border-color 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.upskld_footer_pg_social_btn svg {\n  display: block;\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.upskld_footer_pg_social_btn:hover {\n  transform: translateY(-3px);\n  border-color: transparent;\n  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 12px 24px rgba(74, 26, 158, 0.32);\n  color: #ffffff;\n}\n\n.upskld_footer_pg_social_btn:active {\n  transform: scale(0.94);\n}\n\n/* ---------- Focus ---------- */\n\n.upskld_footer_pg_link:focus-visible,\n.upskld_footer_pg_social_btn:focus-visible,\n.upskld_footer_pg_bar_enquire:focus-visible,\n.upskld_footer_pg_bar_enroll:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 3px;\n  border-radius: 4px;\n}\n\n.upskld_footer_pg_social_btn:focus-visible {\n  border-radius: 50%;\n}\n\n/* ============================================================\n   Divider + bottom row\n   ============================================================ */\n\n.upskld_footer_pg_divider {\n  height: 1px;\n  margin: 28px 0 22px;\n  background: linear-gradient(90deg, rgba(74, 26, 158, 0.08) 0%, rgba(74, 26, 158, 0.22) 50%, rgba(74, 26, 158, 0.08) 100%);\n  transform: scaleX(0);\n  transform-origin: left center;\n  transition: transform 1.1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s;\n}\n\n.upskld_footer_pg_in .upskld_footer_pg_divider {\n  transform: scaleX(1);\n}\n\n.upskld_footer_pg_bottom {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px 40px;\n}\n\n.upskld_footer_pg_sources {\n  max-width: 580px;\n  margin: 0;\n  font-size: 11.5px;\n  line-height: 1.6;\n  color: #5d5978;\n}\n\n.upskld_footer_pg_legal {\n  flex-shrink: 0;\n  gap: 8px 22px;\n}\n\n/* ============================================================\n   Enroll bar (fixed)\n   ============================================================ */\n\n.upskld_footer_pg_bar {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 900;\n  padding: 14px 24px;\n  background: rgba(255, 255, 255, 0.92);\n  -webkit-backdrop-filter: blur(14px);\n  backdrop-filter: blur(14px);\n  box-shadow: 0 -14px 40px rgba(74, 26, 158, 0.14);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  transform: translateY(110%);\n  opacity: 0;\n  pointer-events: none;\n  transition:\n    transform 0.7s cubic-bezier(0.22, 1, 0.36, 1),\n    opacity 0.5s ease;\n}\n\n.upskld_footer_pg_bar *,\n.upskld_footer_pg_bar *::before,\n.upskld_footer_pg_bar *::after {\n  box-sizing: border-box;\n}\n\n.upskld_footer_pg_bar_visible {\n  transform: translateY(0);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.upskld_footer_pg_bar_inner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.upskld_footer_pg_bar_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 8px 18px rgba(74, 26, 158, 0.32);\n  color: #ffffff;\n}\n\n.upskld_footer_pg_bar_text {\n  flex: 1;\n  min-width: 0;\n}\n\n.upskld_footer_pg_bar_title {\n  margin: 0;\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.35;\n  color: #0f0a2a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.upskld_footer_pg_bar_status {\n  margin: 1px 0 0;\n  font-size: 12px;\n  line-height: 1.35;\n  color: #6b6784;\n}\n\n.upskld_footer_pg_bar_actions {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  gap: 10px;\n}\n\n.upskld_footer_pg_bar_enquire,\n.upskld_footer_pg_bar_enroll {\n  padding: 11px 22px;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease, background 0.3s ease;\n}\n\n.upskld_footer_pg_bar_enquire {\n  border: 1px solid #e4dcf9;\n  background: #f0e8ff;\n  color: #4a1a9e;\n}\n\n.upskld_footer_pg_bar_enquire:hover {\n  background: #e4d6ff;\n  transform: translateY(-2px);\n}\n\n.upskld_footer_pg_bar_enroll {\n  border: 0;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 10px 22px rgba(74, 26, 158, 0.34);\n  color: #ffffff;\n}\n\n.upskld_footer_pg_bar_enroll:hover {\n  transform: translateY(-3px);\n  filter: brightness(1.12);\n  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.42);\n}\n\n.upskld_footer_pg_bar_enquire:active,\n.upskld_footer_pg_bar_enroll:active {\n  transform: scale(0.96);\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560 / 360\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .upskld_footer_pg_wrapper {\n    padding: 40px 20px 116px;\n  }\n\n  .upskld_footer_pg_top {\n    column-gap: 28px;\n  }\n\n  .upskld_footer_pg_link_list {\n    gap: 12px 22px;\n  }\n}\n\n/* tablet: brand on its own row, links left + icons right on the next row */\n@media (max-width: 820px) {\n  .upskld_footer_pg_top {\n    grid-template-columns: minmax(0, 1fr) auto;\n    row-gap: 24px;\n    column-gap: 20px;\n  }\n\n  .upskld_footer_pg_brand {\n    grid-column: 1 / -1;\n  }\n\n  .upskld_footer_pg_about {\n    max-width: none;\n  }\n\n  .upskld_footer_pg_link_list {\n    justify-content: flex-start;\n  }\n\n  .upskld_footer_pg_socials {\n    justify-content: flex-end;\n  }\n\n  .upskld_footer_pg_bar {\n    padding: 12px 20px;\n  }\n}\n\n/* mobile: everything stacks, left aligned */\n@media (max-width: 560px) {\n  .upskld_footer_pg_wrapper {\n    padding: 34px 16px 150px;\n  }\n\n  .upskld_footer_pg_top {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 22px;\n  }\n\n  .upskld_footer_pg_logo {\n    font-size: 18px;\n  }\n\n  .upskld_footer_pg_link_list {\n    gap: 10px 20px;\n  }\n\n  .upskld_footer_pg_socials {\n    justify-content: flex-start;\n    gap: 12px;\n  }\n\n  .upskld_footer_pg_divider {\n    margin: 24px 0 18px;\n  }\n\n  .upskld_footer_pg_bottom {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  /* enroll bar: text on top, two buttons below, full width */\n  .upskld_footer_pg_bar {\n    padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .upskld_footer_pg_bar_inner {\n    flex-wrap: wrap;\n    gap: 10px 12px;\n  }\n\n  .upskld_footer_pg_bar_icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .upskld_footer_pg_bar_title {\n    font-size: 13px;\n  }\n\n  .upskld_footer_pg_bar_actions {\n    width: 100%;\n    gap: 8px;\n  }\n\n  .upskld_footer_pg_bar_enquire,\n  .upskld_footer_pg_bar_enroll {\n    flex: 1;\n    padding: 12px 14px;\n  }\n}\n\n@media (max-width: 360px) {\n  .upskld_footer_pg_link {\n    font-size: 13px;\n  }\n\n  .upskld_footer_pg_social_btn {\n    width: 42px;\n    height: 42px;\n  }\n\n  .upskld_footer_pg_bar_title {\n    font-size: 12.5px;\n  }\n}\n\n/* ============================================================\n   Reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .upskld_footer_pg_reveal {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n  }\n\n  .upskld_footer_pg_divider {\n    transform: scaleX(1) !important;\n    transition: none !important;\n  }\n\n  .upskld_footer_pg_bar {\n    transition: opacity 0.2s ease !important;\n    transform: none !important;\n  }\n\n  .upskld_footer_pg_link,\n  .upskld_footer_pg_link::after,\n  .upskld_footer_pg_social_btn {\n    transition: none !important;\n  }\n}\n\n/* ---- header tab switch: program name + status fade in again ---- */\n.upskld_footer_pg_bar_text {\n  animation: upskld_footer_pg_bar_swap 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes upskld_footer_pg_bar_swap {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .upskld_footer_pg_bar_text {\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
